import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
  
import { Observable, AsyncSubject} from 'rxjs';

import { CacheRequestService } from './cache-request.service';
import { delay, tap } from 'rxjs/operators';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(
    private cacheRequestService: CacheRequestService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request);//skip cache in UI/use only cache in API for now 07.08.2020


    if (!this.isCachable(request)) {
      this.cacheRequestService.delete(request.urlWithParams, true);
      //console.log('cache:check', request.urlWithParams);
      return next.handle(request);
    }

    if (request.headers.get('x-cache-refresh')) {

      this.cacheRequestService.delete(request.urlWithParams);

      return next.handle(request);
    }

    const cachedResponse = this.cacheRequestService.get(request.urlWithParams);
    if (cachedResponse) {
      return cachedResponse.pipe(delay(0));
    }

    const subscriber = new AsyncSubject<HttpResponse<any>>();
    this.cacheRequestService.set(request.urlWithParams, subscriber);

    var urlWithParams = request.urlWithParams;

    next.handle(request)
      .subscribe(
        event => {
          if (event instanceof HttpResponse) {
            subscriber.next(event);
            //subscriber.complete();
          }
        },
        error => {
          subscriber.error(error);

          this.cacheRequestService.delete(urlWithParams);
        },
        () => {
          subscriber.complete();
        });

    return subscriber;
  }

  isCachable(request: HttpRequest<any>) {
    return request.method === 'GET' && request.urlWithParams.indexOf('api/') === 0;
  }
}
